export { default } from './BancoDoAutoPerguntas';
